import NBType, { InferType } from '@netbase/nb-type'
import AnnotationDisplayMode from '../enums/AnnotationDisplayMode'
import AuthorSchema from './AuthorSchema'
import AuthorSex from '../enums/AuthorSex'
import AuthorTypeGroup from '../enums/AuthorTypeGroup'
import CVLogoSchema from './CVLogoSchema'
import DateRangeSchema from './DateRangeSchema'
import DayHourSchema from './DayHourSchema'
import Followers from '../enums/Followers'
import GeoFencingSchema from './GeoFencingSchema'
import InsightSchema from './InsightSchema'
import Interest from '../enums/Interest'
import Language from '../enums/Language'
import LxnxFilterSchema from './LxnxFilterSchema'
import MeasurementFilterSchema from './MeasurementFilterSchema'
import MediaType from '../enums/MediaType'
import Mood from '../enums/Mood'
import OrganicPaidPostType from '../enums/OrganicPaidPostType'
import OwnedEarned from '../enums/OwnedEarned'
import PassionOption from '../enums/PassionOption'
import PostSchema from './PostSchema'
import PostType from '../enums/PostType'
import PostTypeGroup from '../enums/PostTypeGroup'
import Profession from '../enums/Profession'
import RecognizedMediaSchema from './RecognizedMediaSchema'
import RichMentionedUrlSchema from './RichMentionedUrlSchema'
import Sentiment from '../enums/Sentiment'
import SentimentDriverSchema from './SentimentDriverSchema'
import SocialWebChannelSchema from './SocialWebChannelSchema'
import Source from '../enums/Source'
import StreamSymbol from '../enums/StreamSymbol'
import VerifiedUsers from '../enums/VerifiedUsers'

const FilterSchema = NBType.object().shape('FilterSchema', {
  /* @prop */
  additionalSentiments: NBType.array().of(NBType.array().of(NBType.enum(Sentiment))),
  /* @prop */
  indexDateTime: DateRangeSchema,
  /* @prop */
  authorTypeGroups: NBType.array().of(NBType.enum(AuthorTypeGroup)),
  /* @prop */
  countries: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  cvLogos: NBType.array().of(CVLogoSchema),
  /* @prop */
  dayHours: NBType.array().of(DayHourSchema),
  /* @prop */
  display: NBType.enum(AnnotationDisplayMode),
  /* @prop */
  domains: NBType.array().of(NBType.string()),
  /* @prop */
  excludedAuthorFingerprint: NBType.array().of(NBType.string()),
  /* @prop */
  excludedAuthors: NBType.array().of(AuthorSchema),
  /* @prop */
  excludedBioTexts: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  excludedChannels: NBType.array().of(SocialWebChannelSchema),
  /* @prop */
  excludedCountries: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  excludedDataStreams: NBType.array().of(NBType.array().of(NBType.enum(StreamSymbol))),
  /* @prop */
  excludedDomains: NBType.array().of(NBType.string()),
  /* @prop */
  excludedEmojis: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  excludedInterests: NBType.array().of(NBType.array().of(NBType.enum(Interest))),
  /* @prop */
  excludedKeywords: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  excludedLanguages: NBType.array().of(NBType.enum(Language)),
  /* @prop */
  excludedNetPromoterScores: NBType.array().of(MeasurementFilterSchema),
  /* @prop */
  excludedPosts: NBType.array().of(NBType.array().of(PostSchema)),
  /* @prop */
  excludedProductHierarchy: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  excludedProfessions: NBType.array().of(NBType.array().of(NBType.enum(Profession))),
  /* @prop */
  excludedSentimentDriver: SentimentDriverSchema,
  /* @prop */
  excludedStarRatings: NBType.array().of(MeasurementFilterSchema),
  /* @prop */
  excludedSurveyScores: NBType.array().of(MeasurementFilterSchema),
  /* @prop */
  excludedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  followers: NBType.array().of(NBType.enum(Followers)),
  /* @prop */
  genders: NBType.array().of(NBType.enum(AuthorSex)),
  /* @prop */
  geoFencings: NBType.array().of(NBType.array().of(GeoFencingSchema)),
  /* @prop */
  hashTags: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  includeTwitterHandle: NBType.boolean(),
  /* @prop */
  includedAuthorFingerprint: NBType.array().of(NBType.string()),
  /* @prop */
  includedAuthors: NBType.array().of(AuthorSchema),
  /* @prop */
  includedBioTexts: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  includedChannels: NBType.array().of(SocialWebChannelSchema),
  /* @prop */
  includedDataStreams: NBType.array().of(NBType.array().of(NBType.enum(StreamSymbol))),
  /* @prop */
  includedEmojis: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  includedInterests: NBType.array().of(NBType.array().of(NBType.enum(Interest))),
  /* @prop */
  includedKeywords: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  includedLanguages: NBType.array().of(NBType.enum(Language)),
  /* @prop */
  includedPosts: NBType.array().of(NBType.array().of(PostSchema)),
  /* @prop */
  includedProductHierarchy: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  includedProductNames: NBType.array().of(NBType.string()),
  /* @prop */
  includedProfessions: NBType.array().of(NBType.array().of(NBType.enum(Profession))),
  /* @prop */
  includedSentimentDriver: SentimentDriverSchema,
  /* @prop */
  includedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  insights: NBType.array().of(NBType.array().of(InsightSchema)),
  /* @prop */
  lxnxFilter: LxnxFilterSchema,
  /* @prop */
  mediaTypes: NBType.array().of(NBType.enum(MediaType)),
  /* @prop */
  mentionedUrls: NBType.array().of(RichMentionedUrlSchema),
  /* @prop */
  mood: NBType.array().of(NBType.array().of(NBType.enum(Mood))),
  /* @prop */
  netPromoterScores: NBType.array().of(MeasurementFilterSchema),
  /* @prop */
  orgProducts: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  organicPaidPostTypes: NBType.array().of(NBType.enum(OrganicPaidPostType)),
  /* @prop */
  ownedEarned: NBType.array().of(NBType.enum(OwnedEarned)),
  /* @prop */
  parentDocIds: NBType.array().of(NBType.string()),
  /* @prop */
  passion: NBType.enum(PassionOption),
  /* @prop */
  people: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  phrases: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  postIds: NBType.array().of(NBType.string()),
  /* @prop */
  postOriginalAuthorIds: NBType.array().of(NBType.string()),
  /* @prop */
  postTypeGroups: NBType.array().of(NBType.enum(PostTypeGroup)),
  /* @prop */
  postTypes: NBType.array().of(NBType.enum(PostType)),
  /* @prop */
  primaryTerms: NBType.array().of(NBType.string()),
  /* @prop */
  publishedDate: DateRangeSchema,
  /* @prop */
  recognizedMedias: NBType.array().of(NBType.array().of(RecognizedMediaSchema)),
  /* @prop */
  removedInsights: NBType.array().of(NBType.string()),
  /* @prop */
  sentiments: NBType.array().of(NBType.array().of(NBType.enum(Sentiment))),
  /* @prop */
  sources: NBType.array().of(NBType.enum(Source)),
  /* @prop */
  starRatings: NBType.array().of(MeasurementFilterSchema),
  /* @prop */
  surveyScores: NBType.array().of(MeasurementFilterSchema),
  /* @prop */
  themeIds: NBType.array().of(NBType.array().of(NBType.number())),
  /* @prop */
  things: NBType.array().of(NBType.string()),
  /* @prop */
  tokenizedPhrases: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  topicIndexOnlyDatetime: DateRangeSchema,
  /* @prop */
  verifiedUsers: NBType.array().of(NBType.enum(VerifiedUsers))
  /* END */
})
export default FilterSchema
export type Filter = InferType<typeof FilterSchema>
// RESERVE BELOW
